import React from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useAppDispatch } from '../../../store'
import { updateTemplate } from '../../../store/templatesNews/actions'
import { IStore } from '../../../store/types'
import { TamplateForm } from '../../../components/Templates/TamplateForm'
import { TypeTemplates } from '../../../utils/consts'
import { ITemplate } from '../../../store/templatesTechSupport/types'

export const NewsEditTamplate: React.FC = () => {
  const [template, setTemplate] = React.useState<ITemplate | null>(null)

  const { id } = useParams()

  const { templatesNews } = useSelector((store: IStore) => store)
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    if (id && templatesNews.currentGroup) {
      const template = templatesNews.currentGroup.templates.find((template) => template.absnum === Number(id))
      if (template) {
        setTemplate(template)
      }
    }
  }, [id, templatesNews.currentGroup])

  const handleCreate = (
    values: { group_id?: number | undefined; product_id: number; message: string },
    callback: (success: boolean) => void
  ) => {
    dispatch(
      updateTemplate({
        id: Number(id),
        data: { ...values, is_type: TypeTemplates.NEWS },
      })
    ).then((res) => {
      if (res.meta.requestStatus !== 'fulfilled') {
        callback(false)
      } else {
        callback(true)
      }
    })
  }

  if (!templatesNews.currentGroup || !template) return null

  return (
    <TamplateForm
      title={`Група ${templatesNews.currentGroup.name}. Шаблон`}
      data={template}
      groupId={templatesNews.currentGroup.absnum}
      createTemplate={handleCreate}
    />
  )
}
